module.exports = __webpack_public_path__ + "img/work.61c19e67.png";